/** Stable display identity for immutable legacy records without a database ID. */
export const displayKey = value => {
  const text = typeof value === "string" ? value : JSON.stringify(value);
  let hash = 2166136261;
  for (const character of text) hash = Math.imul(hash ^ character.charCodeAt(0), 16777619);
  return (hash >>> 0).toString(36);
};